import React from 'react'
import Image from 'next/image'
import { resizeShopifyImage } from '@helpers/shopify'
import imageLoader from '@lib/imageLoader'
import styles from './styles.module.scss'

type ProductCardImageProps = {
  img: string
  imageConfig: {
    imgWidth: string
    imgHeight: string
  }
  title: string
}

const ProductCardImage = ({
  img,
  imageConfig = {
    imgWidth: '328',
    imgHeight: '432'
  },
  title
}: React.PropsWithChildren<ProductCardImageProps>) => {
  const src =
    !img || img === ''
      ? 'https://cdn.shopify.com/s/files/1/0076/2131/2569/files/NoProductImageAvailable.jpg'
      : resizeShopifyImage(img, {
          width: imageConfig.imgWidth,
          height: imageConfig.imgHeight,
          crop: 'center'
        })

  return (
    <div className={styles.image__container}>
      <Image
        src={src}
        alt={title}
        width={Number(imageConfig.imgWidth)}
        height={Number(imageConfig.imgHeight)}
        loader={imageLoader}
      />
    </div>
  )
}

export default ProductCardImage
